// Menu latéral groupé par domaine. Chaque ressource déclarée dans App.js
// DOIT apparaître ici (test : __tests__/menuConfig.test.js) — aucune n'est
// perdue, même les sous-ressources techniques (rangées en fin de groupe).
//
// `label` sert aussi de titre de ressource (options.label dans App.js).

export const MENU_GROUPS = [
  {
    key: "dashboard",
    label: "Tableau de bord",
    icon: "dashboard",
    items: [
      { resource: "stats", label: "Statistiques" },
    ],
  },
  {
    key: "users",
    label: "Utilisateurs",
    icon: "people",
    items: [
      { resource: "patients", label: "Patients" },
      { resource: "professionals", label: "Professionnels" },
      { resource: "practitioners", label: "Validation des pros" },
      { resource: "incomplete-accounts", label: "Comptes incomplets" },
      { resource: "reportedUsers", label: "Signalements" },
      { resource: "reports", label: "Modération" },
      { resource: "users", label: "Tous les comptes" },
      { resource: "patient-search", label: "Recherche patient" },
      { resource: "pro-search", label: "Recherche pro" },
      { resource: "pro-invite", label: "Inviter un pro / patient" },
      { resource: "documents", label: "Documents" },
      { resource: "patient-notes", label: "Notes patient" },
      { resource: "friendships", label: "Relations entre patients" },
      { resource: "favorites", label: "Favoris" },
      { resource: "auth-admin", label: "Outils d'authentification" },
    ],
  },
  {
    key: "bookings",
    label: "Rendez-vous & visio",
    icon: "event",
    items: [
      { resource: "bookings", label: "Rendez-vous" },
      { resource: "awaiting-review", label: "RDV à évaluer" },
      { resource: "pre-consultation", label: "Pré-consultations" },
      { resource: "absences", label: "Absences des pros" },
      { resource: "meetings", label: "Réunions" },
      { resource: "visio", label: "Visioconférences" },
      { resource: "video-sessions", label: "Sessions vidéo" },
      { resource: "recordings", label: "Enregistrements" },
    ],
  },
  {
    key: "payments",
    label: "Paiements",
    icon: "payments",
    items: [
      { resource: "payments", label: "Paiements" },
      { resource: "factures", label: "Factures" },
      { resource: "stripe-connect", label: "Stripe Connect" },
      { resource: "pro-bank-info", label: "RIB des pros" },
      { resource: "ura-transactions", label: "Transactions Ura" },
      { resource: "forfaits", label: "Forfaits" },
      { resource: "eligible-forfaits", label: "Forfaits éligibles" },
      { resource: "pricing", label: "Simulateur de tarifs" },
      { resource: "discount-bonus", label: "Réductions & bonus" },
    ],
  },
  {
    key: "content",
    label: "Contenu",
    icon: "article",
    items: [
      { resource: "articles", label: "Articles" },
      { resource: "echos", label: "Échos" },
      { resource: "events", label: "Événements" },
      { resource: "exercises", label: "Exercices" },
      { resource: "formations", label: "Formations" },
      { resource: "questionnaires", label: "Questionnaires" },
      { resource: "products", label: "Produits" },
      { resource: "pro-videos", label: "Vidéos des pros" },
      { resource: "listings", label: "Petites annonces" },
      { resource: "listing-applications", label: "Candidatures annonces" },
      { resource: "reviews", label: "Avis" },
      { resource: "article-comments", label: "Commentaires articles" },
      { resource: "echo-comments", label: "Commentaires échos" },
      { resource: "event-comments", label: "Commentaires événements" },
      { resource: "pro-exercises", label: "Exercices par pro" },
      { resource: "patient-exercises", label: "Exercices par patient" },
    ],
  },
  {
    key: "care",
    label: "Suivi & gamification",
    icon: "care",
    items: [
      { resource: "follow-up-programs", label: "Programmes de suivi" },
      { resource: "follow-up-entries", label: "Entrées de suivi" },
      { resource: "wellness", label: "Bien-être" },
      { resource: "gamification", label: "Gamification" },
      { resource: "ranking", label: "Classement" },
      { resource: "patient-ranking", label: "Classement patients" },
      { resource: "patient-stats", label: "Stats santé patient" },
    ],
  },
  {
    key: "taxonomy",
    label: "Référentiels",
    icon: "category",
    items: [
      { resource: "specialities", label: "Spécialités" },
      { resource: "suggestions-specialities", label: "Spécialités à valider", badge: "pendingSpecialities" },
      { resource: "jobs", label: "Métiers" },
      { resource: "suggestions-jobs", label: "Métiers à valider" },
      { resource: "traits-hobbies", label: "Traits & loisirs" },
      { resource: "exercise-categories", label: "Catégories d'exercices" },
      { resource: "echo-themes", label: "Thèmes des échos" },
    ],
  },
  {
    key: "referral",
    label: "Parrainage",
    icon: "referral",
    items: [
      { resource: "affiliations", label: "Codes d'affiliation" },
      { resource: "ambassadors", label: "Ambassadeurs" },
      { resource: "affiliation-transactions", label: "Gains d'affiliation" },
      { resource: "referral-dashboard", label: "Tableau parrainage" },
    ],
  },
  {
    key: "support",
    label: "Support & technique",
    icon: "support",
    items: [
      { resource: "support", label: "Support" },
      { resource: "contact", label: "Messages de contact" },
      { resource: "notifications", label: "Notifications" },
      { resource: "email-outbox", label: "File d'emails" },
      { resource: "broadcast-lists", label: "Listes de diffusion" },
      { resource: "chat", label: "Messagerie" },
      { resource: "chatgpt-sessions", label: "Sessions IA" },
      { resource: "test-mail", label: "Test d'email" },
      { resource: "migration-logs", label: "Journal des migrations" },
      { resource: "cache", label: "Cache" },
      { resource: "geocode", label: "Géocodage" },
    ],
  },
];

export const MENU_RESOURCES = MENU_GROUPS.flatMap((g) => g.items.map((i) => i.resource));

export const RESOURCE_LABELS = Object.fromEntries(
  MENU_GROUPS.flatMap((g) => g.items.map((i) => [i.resource, i.label]))
);

export const labelFor = (resource) => RESOURCE_LABELS[resource] || resource;

// Groupe contenant une ressource (pour ouvrir le bon groupe au chargement).
export const groupOf = (resource) =>
  MENU_GROUPS.find((g) => g.items.some((i) => i.resource === resource))?.key;
